import {
  OnInit,
  Component,
  AfterContentInit,
  ElementRef,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ServiceLocator } from '../ServiceLocator';
import { I18nData } from '../api/plyca-dtos';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { BaseComponent } from './common/baseComponent/base.component';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';


export class MessageDTOModal {
  message: string;
  messageData: I18nData;
  titleKeyI18N: string;
  title: string;

  constructor(messageData: string | I18nData, titleKey?: string | I18nData) {

    if (messageData instanceof I18nData) {
      this.messageData = messageData;
    } else {
      this.message = messageData;
    }

    if (titleKey instanceof I18nData) {
      this.titleKeyI18N = titleKey.messageKey;
    } else if (titleKey) {
      this.title = titleKey;
    } else {
      this.titleKeyI18N = 'General.error';
    }
  }
}

@Component({
  selector: 'message',
  templateUrl: 'message.template.html',
  providers: [DialogService]
})
export class messageComponent extends BaseComponent implements OnInit, AfterContentInit {
  @ViewChild('messageContainer', { static: true })
  messageContainer: ElementRef;
  public message: SafeHtml;
  public buttonKey: string
  public title: string;


  constructor(
    public ref: DynamicDialogRef,
    public dialogService: DialogService,
    public dialogConfig: DynamicDialogConfig,
    private sanitizer: DomSanitizer
  ) {
    super();
    let translateService: TranslateService = ServiceLocator.injector.get(
      TranslateService
    );
    //MessageDTOModal
    if (dialogConfig['context'].messageData) {
      this.subscribe(translateService
        .get(
          dialogConfig['context'].messageData.messageKey,
          dialogConfig['context'].messageData.messageParams
        ),
        translation => (this.message = this.sanitizer.bypassSecurityTrustHtml(translation)));
    } else {
      this.message = this.sanitizer.bypassSecurityTrustHtml(dialogConfig['context'].message);
    }

    if (dialogConfig['context'].title) {
      this.title = dialogConfig['context'].title;
    } else if (dialogConfig['context'].titleKeyI18N) {
      this.subscribe(translateService
        .get(dialogConfig['context'].titleKeyI18N),
        translation => (this.title = translation));
    }
    if (dialogConfig.data && dialogConfig.data.buttonKey) {
      this.buttonKey = dialogConfig.data.buttonKey;
    } else {
      this.buttonKey = 'General.close';
    }
  }

  ngOnInit(): void {
    console.log('ngOnInit');
  }

  ngAfterContentInit(): void {
    console.log('ngAfterContentInit');
    //this.messageContainer.nativeElement.innerHTML = this.sanitizer.bypassSecurityTrustHtml(this.message);
  }

  ngOnDestroy() {
    this.dialogConfig = null;
    this.dialogService = null;
    super.ngOnDestroy();
  }

  afterLoadComplete(pdf: PDFDocumentProxy) {
    console.log('afterLoadComplete');
  }

  public isLoaded(): boolean {
    return true;
  }

  public close() {
    console.log('cerrar');
    this.ref.close();
  }
}
